import { Loader } from 'lucide-react-native'
import { MotiView } from 'moti'
import { cssInterop } from 'nativewind'
import React from 'react'
import { View } from 'react-native'
import { Easing } from 'react-native-reanimated'

import { spinner } from '@ui-kit/components/Spinner/styles'
import { COLOR } from '@ui-kit/constants'

import type { Props } from './types'

cssInterop(Loader, {
  className: {
    target: 'style',
  },
})

cssInterop(MotiView, {
  className: {
    target: 'style',
  },
})

const Spinner = (props: Props) => {
  const { container, loader, subContainer } = spinner({
    size: props.size,
    isFullScreen: props.fullScreen,
  })
  return (
    <View testID={props.testID} className={container()}>
      <MotiView
        from={{ rotate: '0deg' }}
        animate={{
          rotate: '360deg',
        }}
        transition={{
          rotate: {
            type: 'timing',
            repeatReverse: false,
            loop: true,
            duration: 1000,
            easing: Easing.linear,
          },
        }}
        className={subContainer()}
      >
        <Loader className={loader()} color={COLOR[props.color ?? 'brandDark']} />
      </MotiView>
    </View>
  )
}

export default Spinner
